













import { Vue, Component, Watch } from 'vue-property-decorator'

const ConfirmAction = () => import(/* webpackChunkName: "ConfirmAction" */ './ConfirmAction.vue')
const Success = () => import(/* webpackChunkName: "Success" */ './Success.vue')
const Error = () => import(/* webpackChunkName: "Error" */ './Error.vue')
const ShareLink = () => import(/* webpackChunkName: "ShareLink" */ './ShareLink.vue')

import { IModalParams, ModalStore, ModalType } from '~/store/modal'
import { Modals } from '@/mixins/modals'

@Component({ components: { ConfirmAction, Success, Error, ShareLink } })
export default class ModalManager extends Vue {
    ModalType = ModalType

    @ModalStore.State('activeModal') activeModal: IModalParams

    // block body scroll if the modals are open
    @Watch('activeModal', { deep: true })
    onActiveModalChange(newValue: IModalParams) {
        if (newValue.modal !== null) {
            document.body.classList.add('noScroll')
            document.body.classList.add('noScroll')
        } else {
            document.body.classList.remove('noScroll')
            document.body.classList.remove('noScroll')
        }
    }
}
